
import EthereumSession from "./eth-session";
import ffABI from "./ffABI";
import truthABI from "./truthABI";

export const CONFIG = {
  chain:         EthereumSession.COMMON_CHAINS[33139],
  infuraId:     '9f57294117e34952877d794e30a0fdbe',
  network:      'mainnet',

  ffAddress:    '0xAcfA101ECE167F1894150e090d9471aeE2dD3041',
  ffABI:         ffABI,

  truthAddress: '0x61588F74226a7E02086B32022C6B4262430393c0',
  truthABI:      truthABI,
};

CONFIG.networkUrl = `https://curtis.rpc.caldera.xyz/http`;


export const ffSession = new EthereumSession({
  contractABI:     CONFIG.ffABI,
  contractAddress: CONFIG.ffAddress,
  chain:           CONFIG.chain
});

export const truthSession = new EthereumSession({
  contractABI:     CONFIG.truthABI,
  contractAddress: CONFIG.truthAddress,
  chain:           CONFIG.chain
});

